import type { AdminThemeConfig } from '@/types/admin-theme';
import { KEILOG_BRAND } from '../../../constants/brand';

/**
 * Keilog site-admin theme.
 * Same BC-* brand tokens as the clinic portal -- see `constants/brand.ts`.
 */
export const keilogAdminTheme: AdminThemeConfig = {
  adminType: 'site',
  siteType: 'keilog',
  siteName: 'KEiLOG 管理ポータル',

  // Admin Theme - Blue
  adminTheme: {
    name: 'Admin',
    displayName: 'KEiLOG Admin',
    colors: {
      primary: KEILOG_BRAND.brand,
      primaryHover: KEILOG_BRAND.brandHover,
      primaryDark: KEILOG_BRAND.brandDeep,
      secondary: KEILOG_BRAND.brandDark,
      secondaryHover: KEILOG_BRAND.brandDeep,
      sidebarBg: KEILOG_BRAND.brand,
      sidebarText: KEILOG_BRAND.surface,
      menuOpen: 'rgba(0, 0, 0, 0.1)',
      menuHover: 'rgba(0, 0, 0, 0.15)',
      menuActive: 'rgba(0, 0, 0, 0.25)',
      sectionHeader: KEILOG_BRAND.brand,
      sectionHeaderText: KEILOG_BRAND.surface,
    },
    logoPath: '/images/keilog/keilog_icon.png',
    sidebarWidth: 'w-60',
  },
};
